<template>
  <el-card shadow="never" class="aui-card--fill">
	 <el-row style="background-color: #F3F4F4;">
		 <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;"><img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />税源地</el-col>
		 <el-col :xs="24" :md="18">
			<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
				<el-form-item>
				  <el-button v-if="$hasPermission('plat:platbody:save')" class="addBtn" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
				</el-form-item>
					<el-form-item>
						<el-button v-if="$hasPermission('plat:platbody:export')" class="exportBtn" type="default" @click="exportHandle()">{{ $t('export') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
					</el-form-item>
				<el-form-item>
				  <el-button v-if="$hasPermission('plat:platbody:delete')" class="delBtn" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
				</el-form-item>
			</el-form>
		 </el-col>
	 </el-row>
    <div class="mod-plat__platbody">

      <el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center">
          <template slot-scope="scope">
            <span>{{(page - 1) * limit + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bodyCode" label="编码" header-align="center" align="center"></el-table-column>
        <el-table-column prop="bodyName" label="税源地" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="taxCode" label="社会信用代码" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bankName" label="开户行" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bankAccount" label="开户账号" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" label="地址" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="taxOfficerName" label="联系人" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="联系电话" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyScale" label="企业规模" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $getDictLabel("companyScale", scope.row.companyScale) }}
          </template>
        </el-table-column>
        <el-table-column prop="isEnable" label="状态" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $getDictLabel("isEnable", scope.row.isEnable) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isEnable === 0 && $hasPermission('plat:platbody:update')" type="text" size="small"
                       @click="$hasPermission('plat:platbody:update') && enableOrDisableHandle(scope.row.id,1)">启用
            </el-button>
            <el-button v-if="scope.row.isEnable === 1 && $hasPermission('plat:platbody:update')" type="text" size="small"
                       @click="$hasPermission('plat:platbody:update') && enableOrDisableHandle(scope.row.id,0)">停用
            </el-button>
            <el-button v-if="$hasPermission('plat:platbody:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('plat:platbody:info')" type="text" size="small" @click="bodyInfoHandle(scope.row.id)">详情</el-button>
            <el-button v-if="$hasPermission('plat:platbody:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            <el-button
              type="text"
              size="small"
              @click="qychildHandleDown(scope.row.id, scope.row.status)"
              >下载服务商清册
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
	  background
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <body-info v-if="infoVisible" ref="infoView" @refreshDataList="getDataList"></body-info>
    </div>
    <!-- 下载选择月份 -->
    <el-dialog
      title="选择月份"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
        <el-date-picker
        v-model="year"
        type="month"
        :picker-options="pickerOptions"
        value-format="yyyy-MM"
        placeholder="选择月">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleExport()">确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import qs from "qs";
import Cookies from "js-cookie";
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platbody-add-or-update'
import bodyInfo from './platbody-info'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          const FullYear = time.getFullYear()
          let myDate = new Date();
          // const Month = time.getMonth() + 1
          if (FullYear < 2018) {
            return true
          } else {
            let t = myDate.getDate();
            // 如果想包含本⽉本⽉ - 8.64e7 * t 就不需要了，
            // 如果想之前的不能选择把 > 换成 <
            return time.getTime() > (Date.now());
          }
          // return false
        },
      },
      year:'',
      dialogVisible:false,
      infoVisible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/body/page',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/body',
        deleteIsBatch: true,
        exportURL: '/sys/plat/body/export'
      },
      dataForm: {
        id: ''
      },
      ExportParams:''
    }
  },
  components: {
    AddOrUpdate,
    bodyInfo
  },
  methods: {
 getdataTime () {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')

      var defaultDate = `${year}-${month}`
      return defaultDate
    },
    // 企业用户下载导出
    qychildHandleDown(id, status) {
     
      this.ExportParams = qs.stringify({
        access_token: Cookies.get("access_token"),
        bodyId: id,
      });
       this.year = this.getdataTime();
      this.dialogVisible = true;
      // this.$http.get(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?${this.ExportParamsparams}`).then(({data:res}) =>  {
      //   if(res.data && res.data.length <= 0){
      //     this.$message.error('当前文档为空！')
      //   }else{
      //      window.open(
      //       `${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?${this.ExportParams}`
      //     );
      //   }
      // })
    },
    handleClose(){
      this.dialogVisible = false;
    },
    handleExport(){
     
      if(this.year == this.getdataTime()){
        this.$http.get(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?${this.ExportParams}`).then((res) => {
          if(res.data.code == 500){
            this.$message.error(res.data.msg)
            return;
          }else{
            window.open(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?${this.ExportParams}`)
          }
        })
      }else{
        this.$http.get(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?month=${this.year}&${this.ExportParams}`).then((res) => {
          if(res.data.code == 500){
            this.$message.error(res.data.msg)
            return;
          }else{
            window.open(`${window.SITE_CONFIG["apiURL"]}/sys/plat/platticketrecord/exportProviderList?month=${this.year}&${this.ExportParams}`)
          }
        })
      }
      this.dialogVisible = false;
    },
    enableOrDisableHandle (id, isEnable) {
      var str = '启用'
      if (isEnable == 0) {
        str = '禁用'
      }
      this.$confirm('此操作将' + str + '此条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handle(id, isEnable)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    
    handle (id, isEnable) {
      this.$http.get('/sys/plat/body/enableOrDisable', {
        params: {
          id: id,
          isEnable: isEnable
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.query()
            }
          })
        }
      }).catch(() => {})
    },
    bodyInfoHandle (id) {
      this.infoVisible = true
      this.$nextTick(() => {
        this.$refs.infoView.init()
		  this.$refs.infoView.dataForm.id = id
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-plat__platbody {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-table {
    flex: 1;
    margin-top: 20px;
    overflow: auto;
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}
</style>